/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import { CircularProgress } from "@mui/material";
import { IReportsResponse } from "../../../store/api/devices/types";
import { useSelector } from "react-redux";
import { selectProfilePermissionsSelector } from "../../../store/api/auth/selectors";
import { useStoreDispatch } from "../../../store/hooks";
import ProfilePermissions from "../../../utils/ProfilePermissions";
import { Icon } from "../../../components/Shared/Icon";
import { Button } from "../../../components/ui/button";
import { useGetDownloadReportMutation } from "../../../store/api/devices/deviceApiSlice";
import { setOpenToast } from "../../../store/helpers/helperReducers";
import { errorMessage, downloadInCSV } from "../../../utils/helpers";
import { useState } from "react";

interface IRowData {
  rowData: IReportsResponse;
}
const DownloadReport: React.FC<IRowData> = ({ rowData }) => {
  const dispatch = useStoreDispatch();
  const permissions: ProfilePermissions | null = useSelector(selectProfilePermissionsSelector);
  const [getDownloadReport, res] = useGetDownloadReportMutation();
  const [isLoading, setIsLoading] = useState(false);

  const downloadClickHandler = async (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    try {
      setIsLoading(true);
      const response: any = await getDownloadReport({ id: rowData.id });
      if (response?.error || res.isError) throw response?.error || res.error;
      downloadInCSV(response, rowData.reportName);
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
    }
  };

  if (!permissions?.hasOpCodeGroup("manage_sn")) {
    return null;
  }

  return isLoading ? (
    <CircularProgress size={20} color="primary" />
  ) : (
    <div className="flex items-center">
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8 shrink-0 bg-transparent text-foreground hover:bg-accent hover:text-foreground"
        aria-label="Download"
        onClick={downloadClickHandler}
      >
        <Icon name="download" size={18} />
      </Button>
    </div>
  );
};

export default DownloadReport;
